import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import {
    faFacebook,
    faInstagram,
    faTwitter,
    faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
    faTrash,
    faBars,
    faCheck,
    faChevronDown,
    faChevronRight,
    faCloudArrowUp,
    faCreditCard,
    faFilter,
    faHeart,
    faHome,
    faCircleCheck,
    faMinus,
    faPlus,
    faSadCry,
    faSearch,
    faShoppingCart,
    faSpinner,
    faStar,
    faTimes,
    faUserCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faFile,
} from "@fortawesome/free-solid-svg-icons";

export function buildIconLibrary(library: FaIconLibrary) {
    library.addIcons(
        faTrash,
        faTwitter,
        faFacebook,
        faCloudArrowUp,
        faInstagram,
        faYoutube,
        faTimes,
        faMinus,
        faPlus,
        faShoppingCart,
        faUserCircle,
        faCreditCard,
        faSearch,
        faSadCry,
        faFilter,
        faBars,
        faHome,
        faChevronDown,
        faCircleCheck,
        faHeart,
        faStar,
        faChevronRight,
        faCheck,
        faSpinner,
        faExclamationCircle,
        faExclamationTriangle,
        faFile
    );
}
